/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./starExplosion.vue?vue&type=template&id=c5a174f2&scoped=true"
import script from "./starExplosion.vue?vue&type=script&lang=js"
export * from "./starExplosion.vue?vue&type=script&lang=js"
import style0 from "./starExplosion.vue?vue&type=style&index=0&id=c5a174f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a174f2",
  null
  
)

export default component.exports